import React, { memo, useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  makeStyles,
  Button,
  CircularProgress,
  MenuItem,
  Divider,
  Typography,
  Tooltip,
  InputAdornment,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { BANK_BASE_URL, JOURNAL_TRANSACTIONS_BASE_URL } from 'constants/url';
import { NumberFormatMask } from 'components';
import { PRIMARY_MOBILE, WHITE } from 'constants/colors';
import { dummyBank, dummyTransactionJurnal } from 'utils/dummy';
import axios from 'axios';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    columnGap: '1em'
  },

  iconLarge: {
    fontSize: '3.5em'
  },
  containerImage: {
    margin: '0.7em 0',
    rowGap: '0.7em'
  },
  browser: {
    color: PRIMARY_MOBILE,
    cursor: 'pointer'
  },
  wrapperImage: {
    columnGap: '1em'
  },
  containerBoxImage: {
    position: 'relative'
  },
  closeImage: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  closeIcon: {
    backgroundColor: 'rgba(32, 42, 61, 0.88)',
    borderRadius: '50%',
    cursor: 'pointer',
    color: WHITE
  },
  tabPanel: {
    flexGrow: 1,
    marginBottom: '20px',
    display: 'flex',

    maxWidth: 500,
    justifyContent: 'center'
  },
  tab: {
    minWidth: 'auto',
    padding: '10px',
    margin: '0 4px'
  }
});
interface Props {
  financialAccounts: AccountCategoryModel[];
  subAccountCategories: AccountCategoryModel[];
  handleCloseCreate: () => void;
  reFetchData: () => void;
  handleSnackBar: (open: boolean, variant: 'success' | 'error', message: string) => void;
}

const CreateEmployeeReceivables = ({ handleSnackBar, financialAccounts, subAccountCategories, handleCloseCreate, reFetchData }: Props) => {
  const classes = useStyles();
  const [transactionJurnal, setTransactionJurnal] = useState<transactionJurnal>(dummyTransactionJurnal);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [isGiroPayment, setIsGiroPayment] = useState<boolean>(false);
  const [banks, setBanks] = useState<BankModel[]>([dummyBank]);
  const disabled =
    Number(transactionJurnal.credit) == 0 ||
    transactionJurnal.accountCategoriesId == -1 ||
    (!isGiroPayment && transactionJurnal.financialAccount == -1) ||
    transactionJurnal.name == '';
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setTransactionJurnal(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async () => {
    setIsSubmit(true);
    try {
      const dataFinal = {
        ...transactionJurnal,
        type: 'Piutang Karyawan'
      };

      const { data } = await axios.post(JOURNAL_TRANSACTIONS_BASE_URL, dataFinal);
      reFetchData();
      reMounted();
      handleSnackBar(true, 'success', 'Transaksi jurnal umum berhasil ditambahkan.');
    } catch (error) {
      console.log(error);
      handleSnackBar(true, 'error', 'Transaksi jurnal umum berhasil gagal ditambahkan.');
    }
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = event.target.value;
    if (/^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
      setTransactionJurnal(prev => ({
        ...prev,
        date: inputDate
      }));
    } else {
      console.error('Invalid date format:', inputDate);
    }
  };

  const reMounted = () => {
    setTransactionJurnal(dummyTransactionJurnal);
    setIsSubmit(false);
    handleCloseCreate();
  };

  const handleCloseCreates = () => {
    reMounted();
    handleCloseCreate();
  };

  const handleSearchBank = async () => {
    try {
      const { data } = await axios.get(`${BANK_BASE_URL}`);
      setBanks(data.data);
    } catch (error) {
      console.log('error', error);
      handleSnackBar(true, 'error', 'BANK_BASE_URL telah gagal');
    } finally {
    }
  };

  useEffect(() => {
    handleSearchBank();
  }, []);

  useEffect(() => {
    const filteredAccounts = financialAccounts.filter(account => account.id === transactionJurnal.financialAccount);

    // Periksa apakah filteredAccounts memiliki elemen sebelum mengakses index 0
    if (filteredAccounts.length > 0) {
      const filterBanks = banks.filter(bank => bank.accountCode === filteredAccounts[0].number);

      // Periksa apakah filterBanks memiliki elemen sebelum mengakses index 0
      if (filterBanks && filterBanks.length > 0) {
        setTransactionJurnal(prev => ({
          ...prev,
          giroDirection: filterBanks[0].bankName,
          giroDirectionId: filterBanks[0].id
        }));
      }
    }
  }, [transactionJurnal.financialAccount, banks, financialAccounts]);

  console.log('transactionJurnal', transactionJurnal);

  return (
    <Grid container direction='row'>
      <Grid xs={12}>
        <Grid container justify='space-between' spacing={2}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Typography variant='h6'>{'Tambah Piutang Karyawan'}</Typography>
            <Divider variant='fullWidth' />
          </Grid>
        </Grid>
        <FormControlLabel
          control={
            <Checkbox
              checked={isGiroPayment}
              onChange={event => {
                const checked = event.target.checked;
                setIsGiroPayment(checked);
                setTransactionJurnal(prev => ({
                  ...prev,
                  paymentGiro: checked
                }));
              }}
              name='giroPayment'
              color='primary'
            />
          }
          label='Pembayaran menggunakan Giro'
        />

        <TextField
          id='financialAccountId'
          required
          label='Akun Bank/Kas'
          value={transactionJurnal.financialAccount as number}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setTransactionJurnal(prev => ({
              ...prev,
              financialAccount: Number(event.target.value)
            }))
          }
          select
          fullWidth
        >
          <MenuItem value={-1} key={'other'}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title='Pilih akun bank atau kas yang menerima dana dalam perusahaan' arrow>
                <InfoOutlinedIcon
                  style={{
                    marginRight: 8,
                    fontSize: 16,
                    color: '#888',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
              Pilih Akun
            </span>
          </MenuItem>
          {financialAccounts.length > 0 &&
            financialAccounts.map((value, index) => (
              <MenuItem key={index} value={value.id}>
                {value.name} - {value.number}
              </MenuItem>
            ))}
        </TextField>

        <TextField
          id='date'
          required
          fullWidth
          name='date'
          label='Tanggal'
          type='date'
          value={transactionJurnal.date || new Date().toISOString().split('T')[0]}
          onChange={handleDateChange}
          InputLabelProps={{
            shrink: true
          }}
        />

        {isGiroPayment && (
          <>
            <TextField
              id='giroNumber'
              placeholder='Nomor Giro'
              required
              fullWidth
              autoComplete='off'
              label='Nomor Giro'
              value={transactionJurnal.giroNumber}
              onChange={handleChange}
            />
            <TextField
              id='giroBank'
              placeholder='Bank Penerbit'
              required
              fullWidth
              autoComplete='off'
              label='Bank Penerbit'
              value={transactionJurnal.giroBank}
              onChange={handleChange}
            />
            <TextField
              id='giroDueDate'
              required
              fullWidth
              name='giroDueDate'
              label='Tanggal Jatuh Tempo'
              type='date'
              value={transactionJurnal.giroDueDate || new Date().toISOString().split('T')[0]}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const inputDate = event.target.value;
                setTransactionJurnal(prev => ({
                  ...prev,
                  giroDueDate: inputDate
                }));
              }}
              InputLabelProps={{
                shrink: true
              }}
            />
          </>
        )}
        <TextField
          id='name'
          placeholder='Nama Transaksi'
          required
          fullWidth
          autoComplete='off'
          label='Nama'
          value={transactionJurnal.name}
          onChange={handleChange}
        />
        <TextField
          id='financialAccount'
          required
          label='Akun Debit'
          value={transactionJurnal.accountCategoriesId as number}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setTransactionJurnal(prev => ({
              ...prev,
              accountCategoriesId: Number(event.target.value)
            }))
          }
          select
          fullWidth
        >
          <MenuItem value={-1} key={'other'}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title='Pilih akun yang akan kredit pada modul akunting' arrow>
                <InfoOutlinedIcon
                  style={{
                    marginRight: 8,
                    fontSize: 16,
                    color: '#888',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
              Pilih Akun
            </span>
          </MenuItem>
          {subAccountCategories.length > 0 &&
            subAccountCategories.map((value, index) => (
              <MenuItem key={index} value={value.id}>
                {value.name} - {value.number}
              </MenuItem>
            ))}
        </TextField>

        <TextField
          id='credit'
          required
          fullWidth
          placeholder='Isi nominal transaksi'
          name='credit'
          autoComplete='off'
          label='Jumlah'
          value={transactionJurnal.credit || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const value = event.target.value;
            setTransactionJurnal(prev => ({
              ...prev,
              credit: Number(value)
            }));
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Tooltip title='Masukkan nominal transaksi' arrow>
                  <InfoOutlinedIcon style={{ cursor: 'pointer', fontSize: 18, color: '#888' }} />
                </Tooltip>
              </InputAdornment>
            ),
            inputComponent: NumberFormatMask as any
          }}
        />

        <TextField
          id='description'
          label='Keterangan'
          placeholder='cth. Transfer sms, Setoran,  Pinjaman dll.'
          multiline
          rows={4}
          variant='outlined'
          fullWidth
          value={transactionJurnal.description}
          onChange={handleChange}
        />
      </Grid>

      <Grid container item lg={12} md={12} sm={12} xs={12} justify='flex-end' className={classes.container}>
        <Button color='secondary' onClick={handleCloseCreates}>
          Batal
        </Button>

        <Button onClick={handleSubmit} disabled={isSubmit || disabled}>
          {isSubmit ? <CircularProgress color='primary' size={20} /> : 'Simpan'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default memo(CreateEmployeeReceivables);
